enum COLORS {
    // Blue
    BLUE_1100 = "#304FAE",
    BLUE_1000 = "#182B63",
    BLUE_900 = "#223D8D",
    BLUE_700 = "#1F41B4",
    BLUE = "#2355FC",
    BLUE_500 = "#4E85FF",
    BLUE_400 = "#70A7FF",
    BLUE_300 = "#98CAFF", // Primary Color - Disabled
    BLUE_200 = "#BFDFFF",
    BLUE_100 = "#DBEFFF", // Primary Background
    BLUE_50 = "#E9F5FF",

    // Red
    RED_800 = "#B91C1C",
    RED_700 = "#991B1B",
    RED_600 = "#B91C1C", // Text Error
    RED = "#DC2626",
    RED_400 = "#EF4444",
    RED_300 = "#F87171",
    RED_200 = "#FCA5A5",
    RED_100 = "#FECACA",

    // Green
    GREEN_700 = "#0F863C",
    GREEN_600 = "#0EA546",
    GREEN_500 = "#19CE5C",
    GREEN_400 = "#42E67E",
    GREEN_300 = "#80F5AA",
    GREEN_200 = "#B8FACF",
    GREEN_100 = "#DAFEE6",

    // Yellow
    YELLOW = "#FFB700",
    YELLOW_500 = "#FFD71B",
    YELLOW_400 = "#FFE846",
    YELLOW_300 = "#FFF485",
    YELLOW_200 = "#FFF9C5", // Accent Background
    YELLOW_100 = "#FFFEEA",

    // Orange
    ORANGE = "#F56700",
    ORANGE_500 = "#FF840A",
    ORANGE_400 = "#FFA132",
    ORANGE_300 = "#FFC56D",
    ORANGE_200 = "#FFDEA5",
    ORANGE_100 = "#FFF0D3",

    // PURPLE
    PURPLE = "#5938FB",
    PURPLE_LIGHT = "#DCD4FF",

    // GREY
    GREY_1000 = "#191919", // Primary Text Color
    GREY_900 = "#383838",
    GREY_800 = "#434343",
    GREY_700 = "#515151", // Secondary Text Color
    GREY_600 = "#666666",
    GREY_500 = "#818181",
    GREY_450 = "#978E8E",
    GREY_400 = "#A4A4A4", // Placeholder Text Color
    GREY_300 = "#C8C8C8", // Disabled Text Color
    GREY_200 = "#E3E3E3", // Subtle Border Color
    GREY_150 = "#EDEDED", // Subtle Border Color
    GREY_100 = "#F7F7F7",
    GREY_50 = "#F6F6F6",

    // COMMON
    WHITE = "#FFFFFF", // Text On Interactive Colors
    BLACK = "#000000",
}

export default COLORS;
